export default __webpack_public_path__ + "static/media/find-and-share-Item-solid.eb27a3c7.svg";